import { useRegisterPhoneNumberModal } from "./data";
import { RegisterPhoneNumberModalUI } from "./ui";

const RegisterPhoneNumberModal = () => {
  const { getRegisterPhoneNumberModal } = useRegisterPhoneNumberModal();
  return <RegisterPhoneNumberModalUI {...getRegisterPhoneNumberModal()} />;
};

export { RegisterPhoneNumberModal };
